import ErrorTwoToneIcon from '@mui/icons-material/ErrorTwoTone';
import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Logo } from '../../components';
import { useSafeNavigation } from '../../hooks/useSafeNavigation';

const TRANS_NS = 'page-error';

export const GeneralErrorPage = () => {
  const { t } = useTranslation(TRANS_NS);
  const { safeNavigate } = useSafeNavigation();

  const onClick = () => {
    safeNavigate('/');
    window.location.reload();
  };

  return (
    <Box height={'100vh'} display={'flex'} flexDirection={'column'}>
      <Box width={'100%'} py={2} px={8} display={'flex'} justifyContent={'center'} alignItems={'center'}>
        <Logo height={32} />
      </Box>
      <Box
        flexGrow={1}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={2}
        textAlign={'center'}
      >
        <ErrorTwoToneIcon color={'error'} sx={{ fontSize: 64 }} />
        <Typography variant={'h1'}>{t('generalError.title')}</Typography>
        <Typography variant={'h3'}>{t('generalError.subtitle')}</Typography>
        <Button onClick={onClick} variant={'contained'} color={'primary'}>
          {t('generalError.action')}
        </Button>
      </Box>
    </Box>
  );
};
